import { Label, List } from "semantic-ui-react";
import { formatCurrency, sumKeyValueOfArray, unFormatCurrency } from "../utils/commonutils";
import FinancialNotesModal from "./FinancialNotesModal";
import React, { useState } from "react";
import moment from "moment/moment";
import PayCalendarDetailsModal from "./PayCalendarDetailsModal";
import EarningSending from "./EarningSending";
import { sendReport } from "../redux/modules/billing";
import { sendReportGox } from "../redux/modules/payReports"
import { sendReportCollections } from "../redux/modules/billing"
import { sendHygienistBillableCareReport } from "../redux/modules/pay"
import CalendarAdjustments from "./PayCalendarDetailsModal/CalendarAdjustments";
import CalendarWriteOffs from "./PayCalendarDetailsModal/CalendarWriteOffs";
import { processFinancialData } from "./CdpReports/services";


export default function PayCalendarCareTopMenus(props) {
    const { user, dispatch, dateKeyObjects, providerPayByPractice, earningsArray } = props;
    const { startDate, practiceListArray, payData, currentPeriod, prevPayTotal, handlePreviousPayDetailsModal } = props;

    const [state, setState] = useState({
        detailsModal: false,
        open: false,
        type: null,
        productionPrice: false,
        familyPractice: null,
        eventClick: false,
        eventDate: false,
    });

    const openPayCalendarDetailsModal = ({ type }) => {
        if (!type) return;
        setState({
            ...state,
            type: type,
            detailsModal: (type === 'billableCare' || type === 'HYNbillableCare') ? 'details' : 'report',
            open: true
        })
    }

    const showFinancialNotes = (returnType, scheduleNotes) => {
        let financialNotesTable = [];
        let financialNotesTableData = [];
        if (scheduleNotes && scheduleNotes.length) {
            let total = 0
            scheduleNotes.forEach((scheduleNote, scheduleKey) => {
                total += parseFloat(scheduleNote.financialNotes) || 0;
                financialNotesTableData.push(scheduleNote)
                financialNotesTable.push(
                    <tr key={`financialNoteRow${scheduleKey}`}>
                        <td>{scheduleNote.notesType}</td>
                        <td>{scheduleNote.dateString}</td>
                        <td>{scheduleNote.title}</td>
                        <td>{scheduleNote.practice}</td>
                        <td>{scheduleNote.dentist}</td>
                        <td>{scheduleNote.desc}</td>
                        <td>{formatCurrency(unFormatCurrency(scheduleNote.financialNotes))}</td>
                    </tr>
                )
            })
            financialNotesTable.push(
                <tr key={`financialNoteRowTotal`}>
                    <td colSpan={6}><strong>Total</strong></td>
                    <td>{formatCurrency(total)}</td>
                </tr>
            )
        }
        const returnObject = { financialNotesTable, financialNotesTableData }
        return returnType.length > 0 ? returnObject[returnType] : financialNotesTable;
    }

    const getDepositDates = (currentDate) => {
        const startOfNextMonth = moment(currentDate).add(1, 'month').startOf('month');
        const dayOfWeek = startOfNextMonth.day();
        const firstFridayDate = 1 + (5 - dayOfWeek + 7) % 7;

        const secondFriday = startOfNextMonth.clone().date(firstFridayDate + 7);
        const fourthFriday = startOfNextMonth.clone().date(firstFridayDate + 21);

        return [secondFriday.format('dddd MMM DD,YYYY'), fourthFriday.format('dddd MMM DD,YYYY')];
    };

    const toggleCalendarDetailsModal = (value) => setState({ ...state, open: value })

    const onSelectEvent = (event, type = 'report', eventClick = 'day') => {
        const excludedEventTypes = new Set(['totalPay', 'dayBonusPay', 'financialNote', 'dayBasePay', 'pay']);
        if (excludedEventTypes.has(event.type)) {
            return;
        }

        setState(prevState => ({
            ...prevState,
            detailsModal: type,
            type: event.type,
            eventClick: eventClick,
            eventDate: event.id,
            ...(event.price && { productionPrice: event.price }),
            ...(event.type === 'familyCapacityView' && { familyPractice: event.practice }),
        }));
    }

    const getPracticeName = (practiceDbName) =>
        practiceListArray.find(p => p.practiceDBName === practiceDbName || p.practice === practiceDbName)?.practice || 'Not found';

    const sendReports = (detailsModalType, detailsModal, eventClick, mtdBillable, productionPrice, eventDate, startDate, hynbCareData = []) => {
        dispatch(sendReport({
            detailsModalType,
            detailsModal,
            eventClick,
            mtdBillable,
            productionPrice,
            eventDate,
            startDate,
            abbr: user.UdaDrList.abbr,
            prodAdjWo: user.UdaDrList.prodAdjWo,
            postedFrom: 'PCPU',
            hynBcareData: hynbCareData
        }))
            .catch((err) => {
                console.log('Err =====>>>>> ', err);
                alert('Email sending failed. Please try again.');
            });
        alert('Sending email...');
        toggleCalendarDetailsModal(false);
    }

    const sendGoxReport = (contractType, doctorName, goxList, bCareData) => {
        const subTitle = ` X-Ray ${contractType} (`
        const title = doctorName + subTitle + moment(startDate).format('MMMM YYYY') + ")";
        dispatch(sendReportGox(title, goxList, bCareData))
            .catch((err) => {
                console.log('Err =====>>>>> ', err);
                alert('Email sending failed. Please try again.');
            });
        alert('Sending email...');
        toggleCalendarDetailsModal(false);
    }

    const sendCollectionsReport = (contractType, doctorName, detailsModal, collectionsList, collEntryStartDate, collProcStartDate) => {
        const subTitle = ` ${contractType} (`
        const title = doctorName + subTitle + moment(startDate).format('MMMM YYYY') + ")";
        dispatch(sendReportCollections(title, detailsModal, collectionsList, collEntryStartDate, collProcStartDate));
        alert('Sending email...');
        toggleCalendarDetailsModal(false);
    }

    const sendHygienistBillableCareReportHandler = () => {
        const abbr = user.UdaDrList.abbr;
        const month = moment(startDate).format('YYYY-MM-DD');
        dispatch(sendHygienistBillableCareReport(abbr, month))
            .then(() => {
                alert('Hygienist billable care report sent successfully!');
                toggleCalendarDetailsModal(false);
            })
            .catch((err) => {
                console.log('Error sending hygienist billable care report:', err);
                alert('Failed to send hygienist billable care report. Please try again.');
            });
    }

    const showSendEarningsReportButton = () => {
        const payValidationRecords = (payData && payData.groupByDoctorByPractice) ? payData.groupByDoctorByPractice.reduce((obj, item) => Object.assign(obj, { [(item.ABBR).toLowerCase()]: item.procBasedPay }), {}) : {}
        return (<EarningSending
            {...props}
            source={'PayCalendarCareTopMenus'}
            type={'cdpReports'}
            endDate={moment(startDate).endOf('month').format('YYYY-MM-DD')}
            selectedDoctors={[user.UdaDrList.abbr]}
            payValidation={payValidationRecords}
            sendToProviders={false}
            payDataByProvider={payData ? payData.groupByDoctorByPractice : []}
        />)
    }

    const {
        doctorName = '',
        dataBCare = [],
        contractType = '',
        isProviderOnTierBonus,
        GoxNonBillableCare,
        teamContribution,
        bCare: mtdbCareTotal
    } = providerPayByPractice ?? {};

    // --- Derived data from earningsArray ---
    const totalEarnings = sumKeyValueOfArray(earningsArray, 'practiceTotalPay');
    const totalFinancialNotes = sumKeyValueOfArray(earningsArray, 'financialNotes');
    const totalBasePay = sumKeyValueOfArray(earningsArray, 'newBasePay');
    const totalBonus = sumKeyValueOfArray(earningsArray, 'postBonus');

    const tierBonusPayRecords = earningsArray.map(p => p.tierBonusPayRecords ?? []);
    const financialNoteList = earningsArray.flatMap(p => p.financialNoteList ?? []);
    const goxList = earningsArray.flatMap(p => p.goxList ?? []);
    const providerCustomRates = earningsArray.flatMap(p => p.customProviderRates ?? []);
    const payDetailsList = earningsArray.flatMap(p => p.payDetailsList ?? []);
    const goGaSummaries = earningsArray.map(p => p.goGaSummary).filter(Boolean);

    const mapCollectionCategory = (collection) => ({
        ...collection,
        Category: collection?.Category === 'Cash_Split' ? 'PT Income' :
            collection?.Category === 'Claim_pay' ? 'Ins Income' :
                collection?.Category
    });

    const collectionsList = earningsArray.flatMap(p => p.collectionList ?? []).map(mapCollectionCategory);
    const hygCollectionList = earningsArray.flatMap(p => p.hygCollectionList ?? []).map(mapCollectionCategory);
    const hygienistBCareList = earningsArray.flatMap(p => p.hygienistProductionMatchingProviderTreatments ?? []);

    const totalCollections = sumKeyValueOfArray(collectionsList, 'Amount');
    const totalHygCollections = sumKeyValueOfArray(hygCollectionList, 'Amount');

    console.log('DEBUG [Tapiwa Gomo]: earningsArray', earningsArray);
    const isHybridProvider = earningsArray.some(p => p.isHybridContract);
    console.log('DEBUG [Tapiwa Gomo]: isHybridProvider', isHybridProvider);
    const totalTedCollections = sumKeyValueOfArray(collectionsList.filter(c => c.isTedDay), 'Amount');

    const sumCollectionsDates = contractType === 'Collections w/HYN' ? earningsArray.flatMap(p => Object.keys(p.sumCollectionsTotalByDate ?? {})) : [];
    const sumCollectionsTotalByDate = contractType === 'Collections w/HYN' ? earningsArray.map(p => p.sumCollectionsTotalByDate) : [];

    const depositDates = getDepositDates(startDate);
    const hynbCareTotal = sumKeyValueOfArray(earningsArray, 'hynBillableCare');


    const payChecks = depositDates.reduce((acc, date, idx) => {
        acc[date] = { total: 0, officeChecks: [] };

        earningsArray.forEach(iPractice => {
            const financialNotesValue = Number(iPractice?.financialNotes) || 0;
            const totalPracticePayValue = Number(iPractice?.practiceTotalPay) || 0;
            let checkAmount = (totalPracticePayValue - financialNotesValue) / 2;

            (iPractice.financialNoteList || []).forEach(note => {
                const noteAmount = Number(note?.financialNotes) || 0;
                const frequency = String(note?.frequency || "").trim().toLowerCase();
                if ((frequency === 'first' && idx === 0) || (frequency === 'second' && idx === 1)) {
                    checkAmount += noteAmount;
                } else if (frequency === 'split') {
                    checkAmount += noteAmount / 2;
                }
            });

            acc[date].total += checkAmount;
            acc[date].officeChecks.push({ practice: iPractice.practiceInfo[0].practice, check: checkAmount });
        });
        return acc;
    }, {});


    // --- Calculations ---
    const financialNoteTotal = sumKeyValueOfArray(financialNoteList, 'financialNotes');
    const financialNotesTable = showFinancialNotes('financialNotesTable', financialNoteList);
    const sortedTierBonusPayRecords = tierBonusPayRecords.sort((a, b) => a.amountFrom - b.amountFrom);

    const writeoffArr = processFinancialData(providerPayByPractice.dataWriteOff, 'WriteOff', -1);
    const adjustmentArr = processFinancialData(providerPayByPractice.dataAdjustment, 'AdjAmt');

    const writeOffs = Object.values(writeoffArr ?? {}).flat(1);
    const adjustments = Object.values(adjustmentArr ?? {}).flat(1);
    const billableCareData = dataBCare.concat(writeOffs).concat(adjustments);

    const modalDetails = {
        header: contractType,
        contractType: contractType,
        billableCareData,
        providerAbbr: user.UdaDrList.abbr,
        goxList,
        collectionsList,
        financialNoteList: financialNoteList,
        payDetailsList,
        goGaSummaries,
        financialNotes: financialNotesTable,
        payChecks: payChecks,
        providerCustomRates: providerCustomRates,
        hygData: dateKeyObjects,
        hygCollectionList,
        sumCollectionsTotalByDate,
        sumCollectionsDates,
        hynBCareData: hygienistBCareList,
        tierBonusPayRecords: sortedTierBonusPayRecords,
        isProviderOnTierBonus: isProviderOnTierBonus,
        collectionsEntryStartDate: "00-00",
        collectionsProcedureStartDate: "00-00"
    }

    const sendEarningsReportButton = showSendEarningsReportButton({ help: 12345 });
    const mtdBillable = formatCurrency(mtdbCareTotal ?? 0);
    const teamAmount = `${teamContribution > 0 ? '+' : ''}${formatCurrency(teamContribution)}`;

    const menuItems = [
        {
            show: ['Greater Of', 'Greater Of w/HYN'].includes(contractType),
            label: 'MTD Base Pay',
            value: formatCurrency(totalBasePay),
            onClick: () => openPayCalendarDetailsModal({ type: 'earnings', details: modalDetails }),
        },
        {
            show: ['Sum Of', 'Sum Of w/HYN'].includes(contractType),
            label: 'MTD Bonus Pay',
            value: formatCurrency(totalBonus),
            onClick: () => openPayCalendarDetailsModal({ type: 'earnings', details: modalDetails }),
        },
        {
            show: ['GOX', 'GOX w/HYN', 'GOZ'].includes(contractType),
            label: contractType === 'GOZ' ? 'GOZ' : 'GOX',
            value: formatCurrency(GoxNonBillableCare),
            onClick: () => openPayCalendarDetailsModal({ type: 'goxBillableCare', details: modalDetails }),
        },
        {
            show: ['Collections', 'Collections w/HYN'].includes(contractType),
            label: 'Collections',
            value: formatCurrency(totalCollections),
            onClick: () => openPayCalendarDetailsModal({ type: 'collectionsBillableCare', details: modalDetails }),
        },
        {
            show: contractType === 'Collections w/HYN',
            label: 'Collections/HYN',
            value: formatCurrency(totalHygCollections),
            onClick: () => openPayCalendarDetailsModal({ type: 'collectionsHynList', details: modalDetails }),
        },
        {
            show: isHybridProvider,
            label: 'TED Collections',
            value: formatCurrency(totalTedCollections),
            onClick: () => openPayCalendarDetailsModal({ type: 'tedCollections', details: modalDetails }),
        },
        {
            show: !['Collections w/HYN', 'Collections'].includes(contractType),
            label: <>MTD <sub>b</sub>Care</>,
            value: formatCurrency(mtdbCareTotal),
            onClick: () => openPayCalendarDetailsModal({ type: 'billableCare', details: modalDetails }),
        },
        {
            show: ['Greater Of w/HYN', 'Sum Of w/HYN', 'GOX w/HYN'].includes(contractType),
            label: <>MTD <sub>b</sub>Care/HYN</>,
            value: earningsArray.length > 0 ? formatCurrency(hynbCareTotal) : formatCurrency(0),
            onClick: () => openPayCalendarDetailsModal({ type: 'HYNbillableCare', details: modalDetails }),
        },
        {
            show: true,
            component: (
                <List.Item key="fin-note">
                    <span>
                        Fin Note: <FinancialNotesModal
                            financialNoteTotal={formatCurrency(financialNoteTotal)}
                            financialNotes={financialNoteList}
                            trigger={<b> {formatCurrency(totalFinancialNotes)}</b>} />
                    </span>
                </List.Item>
            )
        },
        {
            show: true,
            label: 'Earnings Report',
            value: contractType !== 'UKG HYN' ? formatCurrency(totalEarnings) : formatCurrency(0),
            onClick: () => openPayCalendarDetailsModal({ type: 'earnings', details: modalDetails }),
        },
        {
            show: ['Collections', 'Collections w/HYN'].includes(contractType),
            label: 'Previous Pay',
            value: `${formatCurrency(prevPayTotal ?? 0)}`,
            onClick: () => handlePreviousPayDetailsModal(true),
        },
        { show: true, component: <List.Item key="adjustments"><CalendarAdjustments {...props} getPracticeName={getPracticeName} /></List.Item> },
        { show: true, component: <List.Item key="writeoffs"><CalendarWriteOffs {...props} getPracticeName={getPracticeName} /></List.Item> },
        { show: !!teamContribution, component: <List.Item key="team-contribution">Team Contribution: <Label basic={true} color={teamContribution > 0 ? 'green' : 'red'} content={teamAmount} /></List.Item> },
    ];

    return (<>
        {state.open && <PayCalendarDetailsModal
            {...state}
            toggleCalendarModal={toggleCalendarDetailsModal}
            modalDetails={modalDetails}
            onSelectEvent={onSelectEvent}
            providerData={providerPayByPractice}
            startDate={startDate}
            earnings={totalEarnings}
            basePay={totalBasePay}
            getPracticeName={getPracticeName}
            doctorName={doctorName}
            sendEarningsReportButton={sendEarningsReportButton}
            sendReport={sendReports}
            mtdBillable={mtdBillable}
            sendGoxReport={sendGoxReport}
            contractType={contractType}
            sendCollectionsReport={sendCollectionsReport}
            sendHygienistBillableCareReport={sendHygienistBillableCareReportHandler}
            currentPeriod={currentPeriod}
        />}
        <List horizontal className="topValues test">
            {menuItems.map((item, key) => {
                if (!item.show) return null;
                if (item.component) return item.component;
                return (
                    <List.Item key={item.label + key}>
                        <span onClick={item.onClick}>
                            {item.label}: <b> {item.value}</b>
                        </span>
                    </List.Item>
                );
            })}
        </List>
    </>
    )
}